/**
 * Playlists slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { Playlist } from '../../store/slices/types';

const initialState = {
  playlists: [] as Playlist[],
  currentPlaylist: null as Playlist | null,
  loading: false,
  error: null as string | null,
};

const playlistsSlice = createSlice({
  name: 'playlists',
  initialState,
  reducers: {
    setPlaylists(state, action) {
      state.playlists = action.payload;
      state.loading = false;
      state.error = null;
    },
    setCurrentPlaylist(state, action) {
      state.currentPlaylist = action.payload;
      state.loading = false;
      state.error = null;
    },
    addPlaylist(state, action) {
      state.playlists.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    updatePlaylist(state, action) {
      const index = state.playlists.findIndex(
        (p) => (p._id || p.id) === (action.payload._id || action.payload.id)
      );
      if (index !== -1) {
        state.playlists[index] = action.payload;
      }
      if (state.currentPlaylist && (state.currentPlaylist._id || state.currentPlaylist.id) === (action.payload._id || action.payload.id)) {
        state.currentPlaylist = action.payload;
      }
      state.loading = false;
      state.error = null;
    },
    removePlaylist(state, action) {
      state.playlists = state.playlists.filter(
        (p) => (p._id || p.id) !== action.payload
      );
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

// Reducer
export const playlistsReducer = playlistsSlice.reducer;

// Actions
export const {
  setPlaylists,
  setCurrentPlaylist,
  addPlaylist,
  updatePlaylist,
  removePlaylist,
  setLoading,
  setError,
  clearError,
} = playlistsSlice.actions;

// Async Actions
export const fetchPlaylists = createAction('PLAYLISTS/FETCH_ALL');
export const fetchPlaylist = createAction<string>('PLAYLISTS/FETCH_ONE');
export const createPlaylist = createAction<Omit<Playlist, '_id' | 'id'>>('PLAYLISTS/CREATE');
export const updatePlaylistAction = createAction<{ id: string; data: Partial<Playlist> }>('PLAYLISTS/UPDATE');
export const deletePlaylist = createAction<string>('PLAYLISTS/DELETE');

